module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "sidebar"
    }
  }, [_c('aside', {
    staticClass: "sidebar"
  }, [_c('svg', {
    staticClass: "sidebar__background",
    attrs: {
      "viewBox": "0 0 234 354",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "id": "0",
      "d": "M176.848 353.694H0V0H353.695v353.694z"
    }
  }), _c('mask', {
    attrs: {
      "id": "1",
      "fill": "#fff"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#0"
    }
  })])]), _c('path', {
    attrs: {
      "d": "M258.914 241.705l-52.691-52.69h74.57c-2.3 19.759-10.12 37.846-21.879 52.69m-69.898 39.083V206.22l52.693 52.69c-14.847 11.758-32.933 19.577-52.693 21.877m-77.027-21.876l52.69-52.69v74.566c-19.759-2.3-37.845-10.119-52.69-21.876m-39.083-69.897h74.567l-52.691 52.69c-11.758-14.844-19.576-32.931-21.876-52.69m21.876-77.028l52.691 52.691H72.906c2.3-19.759 10.118-37.845 21.876-52.691m69.897-39.085v74.57l-52.692-52.691C126.834 83.023 144.92 75.2 164.68 72.9m77.028 21.88l-52.691 52.692V72.902c19.76 2.3 37.846 10.12 52.691 21.879m39.085 69.897h-74.57l52.694-52.69c11.757 14.845 19.576 32.931 21.876 52.69m60.735 0h-17.463c-2.588-31.601-15.168-60.413-34.564-83.273l12.398-12.4c4.755-4.75 4.755-12.456 0-17.206-4.745-4.755-12.46-4.753-17.206-.003l-12.4 12.4C249.432 44.8 220.619 32.22 189.016 29.63v-17.46c0-6.72-5.449-12.17-12.167-12.17-6.722 0-12.17 5.45-12.17 12.17v17.46c-31.603 2.59-60.414 15.17-83.274 34.569l-12.397-12.4c-4.747-4.754-12.461-4.752-17.207-.002-4.755 4.753-4.755 12.458 0 17.208l12.399 12.4c-19.398 22.86-31.976 51.672-34.566 83.274H12.17c-6.721 0-12.17 5.449-12.17 12.169 0 6.72 5.449 12.168 12.17 12.168h17.465c2.59 31.602 15.17 60.413 34.567 83.272l-12.4 12.4c-4.755 4.75-4.755 12.456 0 17.207a12.125 12.125 0 0 0 8.602 3.565c3.113 0 6.23-1.188 8.605-3.565l12.399-12.4c22.858 19.397 51.67 31.976 83.272 34.565v17.467c0 6.72 5.448 12.168 12.17 12.168 6.718 0 12.167-5.448 12.167-12.168V324.06c31.603-2.59 60.416-15.17 83.275-34.568l12.4 12.401a12.125 12.125 0 0 0 8.604 3.565c3.113 0 6.23-1.188 8.603-3.565 4.755-4.75 4.755-12.457 0-17.207l-12.4-12.4c19.397-22.859 31.978-51.67 34.566-83.272h17.463c6.72 0 12.168-5.447 12.168-12.168 0-6.72-5.448-12.169-12.168-12.169",
      "fill": "#fff",
      "mask": "url(#1)",
      "transform": "translate(-120)",
      "fill-rule": "evenodd"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "sidebar__header"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('svg', {
    staticClass: "sidebar__logo",
    attrs: {
      "viewBox": "0 0 150 29",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "fill": "#fff",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "d": "M16.712 19.46c0 5.74-4.14 8.11-8.355 8.11-4.235 0-8.356-2.37-8.356-8.11V9.07h3.952v10.03c0 3.483 1.937 4.762 4.404 4.762 2.464 0 4.403-1.28 4.403-4.762V9.071h3.952V19.46M31.962 13.588c-1.091-.677-3.33-1.543-5.57-1.543-2.146 0-3.407.865-3.407 2.145 0 1.26 1.317 1.618 2.974 1.864l1.863.282c3.933.565 6.267 2.239 6.267 5.326 0 3.463-3.01 5.89-8.206 5.89-1.863 0-5.1-.357-7.735-2.314l1.826-2.955c1.3.995 3.011 1.843 5.947 1.843 2.69 0 4.103-.848 4.103-2.202 0-1.016-.979-1.693-3.124-1.995l-1.882-.243c-3.99-.548-6.117-2.39-6.117-5.288 0-3.577 2.86-5.779 7.454-5.779 2.822 0 5.438.696 7.3 1.901l-1.693 3.068M68.202 9.108l-.94 3.895c-.829-.432-2.034-.657-2.993-.657-2.503 0-4.291 1.768-4.291 4.837V27.1h-3.934V9.072h3.896v2.032C61.126 9.39 62.97 8.6 65.172 8.6c1.204 0 2.126.15 3.03.508M74.38 18.085c0 3.294 2.183 5.778 5.438 5.778 3.389 0 5.44-2.615 5.44-5.778 0-3.16-2.051-5.776-5.44-5.776-3.255 0-5.438 2.483-5.438 5.776m14.923 0c0 5.515-3.97 9.486-9.015 9.486-2.558 0-4.403-1.037-5.645-2.616V27.1H70.71V0h3.933v11.217C75.885 9.637 77.73 8.6 80.288 8.6c5.044 0 9.015 3.97 9.015 9.484M116.907 18.085c0 3.163 2.051 5.778 5.439 5.778 3.256 0 5.44-2.484 5.44-5.778 0-3.293-2.184-5.776-5.44-5.776-3.388 0-5.439 2.615-5.439 5.776m14.567 9.015h-3.934v-2.164c-1.243 1.598-3.105 2.635-5.665 2.635-5.044 0-9.013-3.971-9.013-9.486 0-5.514 3.97-9.484 9.013-9.484 2.56 0 4.422 1.053 5.665 2.653V9.072h3.934V27.1M148.437 12.647h-6.907v7.848c0 2.427 1.28 3.37 2.861 3.37 1.223 0 2.56-.548 3.633-1.225l1.561 3.144c-1.45.978-3.274 1.786-5.532 1.786-4.084 0-6.475-2.2-6.475-7v-7.923h-3.594V9.07h3.594V3.613h3.952V9.07h6.907v3.576M52.67 18.067c-.02-5.628-3.482-9.465-8.526-9.465-5.307 0-8.977 3.837-8.977 9.484 0 5.72 3.821 9.485 9.222 9.485 2.729 0 5.212-.66 7.414-2.542l-1.956-2.803c-1.487 1.186-3.407 1.9-5.214 1.9-2.56 0-4.836-1.355-5.363-4.592-.283-1.177-.047-2.647.02-2.992h-.002c.415-2.634 1.977-4.441 4.78-4.441 2.505 0 4.14 1.638 4.575 4.441h-7.241l1.118 2.992h10.074c.039-.451.075-.959.075-1.467M101.043 12.27a5.822 5.822 0 0 0-5.816 5.816 5.822 5.822 0 0 0 5.816 5.814 5.822 5.822 0 0 0 5.816-5.814 5.822 5.822 0 0 0-5.816-5.816m0 14.804c-4.957 0-8.99-4.033-8.99-8.988 0-4.957 4.033-8.99 8.99-8.99 4.956 0 8.989 4.033 8.989 8.99 0 4.955-4.033 8.988-8.99 8.988"
    }
  }), _c('path', {
    attrs: {
      "d": "M101.043 18.826a.74.74 0 0 1-.74-.74V8.063a.741.741 0 0 1 1.48 0v10.021a.74.74 0 0 1-.74.74"
    }
  }), _c('path', {
    attrs: {
      "d": "M101.043 18.826a.74.74 0 0 1-.524-1.264l7.085-7.086a.74.74 0 0 1 1.048 1.048l-7.086 7.085a.738.738 0 0 1-.523.217"
    }
  }), _c('path', {
    attrs: {
      "d": "M111.063 18.826h-10.021a.741.741 0 0 1 0-1.481h10.021a.74.74 0 1 1 0 1.48"
    }
  }), _c('path', {
    attrs: {
      "d": "M108.128 25.912a.738.738 0 0 1-.523-.217l-7.086-7.086a.74.74 0 0 1 1.047-1.047l7.086 7.086a.74.74 0 0 1-.524 1.264"
    }
  }), _c('path', {
    attrs: {
      "d": "M101.043 28.847a.74.74 0 0 1-.74-.74V18.084a.741.741 0 0 1 1.48 0v10.021a.74.74 0 0 1-.74.74"
    }
  }), _c('path', {
    attrs: {
      "d": "M93.957 25.912a.74.74 0 0 1-.524-1.264l7.086-7.086a.74.74 0 0 1 1.047 1.047l-7.086 7.086a.738.738 0 0 1-.523.217"
    }
  }), _c('path', {
    attrs: {
      "d": "M101.043 18.826H91.02a.74.74 0 1 1 0-1.481h10.022a.74.74 0 1 1 0 1.48"
    }
  }), _c('path', {
    attrs: {
      "d": "M101.043 18.826a.738.738 0 0 1-.524-.217l-7.086-7.085a.74.74 0 0 1 1.048-1.048l7.085 7.086a.74.74 0 0 1-.523 1.264"
    }
  })])])])], 1), _vm._v(" "), _c('nav', _vm._l((_vm.routes), function(route) {
    return (!route.meta.hiddenFromNav) ? _c('router-link', {
      staticClass: "sidebar__link",
      attrs: {
        "to": route.path,
        "active-class": "sidebar__link--active"
      }
    }, [_c('span', {
      staticClass: "sidebar__label"
    }, [_c('i', {
      staticClass: "icon",
      class: ("icon--" + (route.meta.icon))
    }), _vm._v("\n          " + _vm._s(route.meta.label) + "\n        ")])]) : _vm._e()
  }), 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-77652ace!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/layout/Sidebar.vue
// module id = 749
// module chunks = 1